import React, { useState, useEffect } from "react";
import Header from "./Header";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import { Add_designation_text } from "../CommonJquery/WebsiteText";
import {
  handleAphabetsChange,
  check_vaild_save,
  combiled_form_data,
  handleSuccessSession,
  handleError,
  handleIaphabetnumberChange,
  handleNumbersDecimalChange,
  handleAlphabetsNumberWithoutSpaceChange,
} from "../CommonJquery/CommonJquery";
import {
  server_post_data,
  create_update_vacancy,
  get_admin_designation,
} from "../ServiceConnection/serviceconnection.js";
import { Link, useLocation } from "react-router-dom";
function AddVacancy() {
  const location = useLocation();
  const currentUrl = location.pathname.substring(1);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editorDataMainID, setEditorDatMainID] = useState("0");

  const [editStaffDataDetails, seteditStaffDataDetails] = useState([]);
  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);
    // const checkboxes = document.querySelectorAll(".checkboxclass");
    // let access_list = "";
    // Loop through each checkbox
    // checkboxes.forEach((checkbox) => {
    //   if (checkbox.checked == true) {
    //     access_list += "/" + checkbox.value;
    //   }
    //   if (checkbox.hasAttribute("insidepagehave")) {
    //     const insidePageValue = checkbox.getAttribute("insidepagehave");
    //     const insideDiv = document.querySelector(
    //       ".insidemain" + insidePageValue
    //     );
    //     if (insideDiv) {
    //       const innerCheckboxes = insideDiv.querySelectorAll(
    //         'input[type="checkbox"]'
    //       );
    //       innerCheckboxes.forEach((innerCheckbox) => {
    //         if (innerCheckbox.checked == true) {
    //           access_list += "@" + innerCheckbox.value;
    //         }
    //       });
    //     }
    //   }
    // });
    // if (access_list.startsWith("/")) {
    //   access_list = access_list.substring(1);
    // }
    // if (access_list == "") {
    // alert("Please Select Staff Rights");
    // } else {
    if (vaild_data) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      fd_from.append("main_id", editorDataMainID);
      // fd_from.append("access_list", access_list);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          console.log(Response.data.message);
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            handleSuccessSession(Response.data.message, "/ViewCareer");
          }
        })
        .catch((error) => {
          setshowLoaderAdmin(false);
          handleError(
            Add_designation_text.error_message_toast_handleSaveChangesDyanamic
          );
        });
    }
    // }
  };

  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}
      <div className="dashboard_container">
        <Header />
        <div className="page_content">
          <div className="page_content_container">
            <div className="pageCntn_head" style={{ top: "0px" }}>
              <div className="pageNameDiv">
                <p>
                  {location.pathname.includes("/Edit_Designation") ? (
                    <p>Edit Vacancy</p>
                  ) : (
                    <p>Add Vacancy</p>
                  )}
                </p>
                <img src={GreyArrow} alt="Uprestro Dashboard" />
              </div>
            </div>

            <div className="page_body mrginClsss">
              <div className="create_staffRights staffForm_container ">
                <form id="addNewStaff">
                  <div className="event-box blog-data">
                    <div className="form-group AddVacancyForm">
                      <div className="row m-0">
                        <div className="col-md-4">
                          <div className="inpContainer inpContainerSeo mt-2">
                            <label className="no_prsnl_id">Job Title </label>
                            <input
                              type="text"
                              name="designation"
                              defaultValue={
                                editStaffDataDetails.designation || ""
                              }
                              id="designation"
                              maxLength={60}
                              minLength={3}
                              onInput={handleAphabetsChange}
                              className="form-control trio_mandatory"
                              placeholder="Enter Job Title* "
                            />
                            <span className="condition_error"></span>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="inpContainer inpContainerSeo mt-2">
                            <label className="no_prsnl_id">Location </label>
                            <input
                              type="text"
                              name="loaction"
                              defaultValue={
                                editStaffDataDetails.loaction || ""
                              }
                              id="loaction"
                              maxLength={300}
                              minLength={1}
                              // onInput={handleIaphabetnumberChange}
                              className="form-control trio_mandatory"
                              placeholder="Enter Job Location* "
                            />
                            <span className="condition_error"></span>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="inpContainer inpContainerSeo mt-2">
                            <label className="no_prsnl_id">Package</label>
                            <input
                              type="text"
                              name="salary_details"
                              defaultValue={editStaffDataDetails.salary_details || ""}
                              id="salary_details"
                              // maxLength={10}
                              // minLength={1}
                              // onInput={hande}
                              className="form-control trio_mandatory"
                              placeholder="Enter Package* "
                            />
                            <span className="condition_error"></span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="inpContainer inpContainerSeo mt-2">
                            <label className="no_prsnl_id">
                              Min Experience
                            </label>
                            <input
                              type="text"
                              name="min_experience"
                              defaultValue={
                                editStaffDataDetails.min_experience || ""
                              }
                              id="min_experience"
                              maxLength={10}
                              minLength={1}
                              onInput={handleNumbersDecimalChange}
                              className="form-control trio_mandatory"
                              placeholder="Enter Min Experience* "
                            />
                            <span className="condition_error"></span>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer inpContainerSeo mt-2">
                            <label className="no_prsnl_id">
                              Max Experience
                            </label>
                            <input
                              type="text"
                              name="max_experience"
                              defaultValue={
                                editStaffDataDetails.max_experience || ""
                              }
                              id="max_experience"
                              maxLength={10}
                              minLength={1}
                              onInput={handleNumbersDecimalChange}
                              className="form-control trio_mandatory"
                              placeholder="Enter Max Experience* "
                            />
                            <span className="condition_error"></span>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="inpContainer inpContainerSeo mt-2">
                            <label className="no_prsnl_id">
                              Job Requirements (Skills){" "}
                            </label>
                            <textarea
                              type="text"
                              name="skills"
                              defaultValue={editStaffDataDetails.skills || ""}
                              id="skills"
                              maxLength={300}
                              minLength={1}
                              onInput={handleIaphabetnumberChange}
                              className="textareBlogs mt-0 form-control trio_mandatory"
                              placeholder="Enter Skills* "
                            ></textarea>
                            <span className="condition_error"></span>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="inpContainer inpContainerSeo mt-2">
                            <label className="no_prsnl_id">Job Summary</label>
                            <textarea
                              type="text"
                              name="job_description"
                              defaultValue={editStaffDataDetails.job_description || ""}
                              id="job_description"
                              maxLength={300}
                              minLength={1}
                              onInput={handleIaphabetnumberChange}
                              className="textareBlogs mt-0 form-control trio_mandatory"
                              placeholder="Enter Summary* "
                            ></textarea>
                            <span className="condition_error"></span>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="addBlogBtnDiv">
                            <button
                              type="button"
                              onClick={() =>
                                handleSaveChangesdynamic(
                                  "addNewStaff",
                                  create_update_vacancy
                                )
                              }
                              className="btn btn-secondary mt-3 mb-2 save-cap-btn"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddVacancy;
